import BrackLogo from 'dd-client/core/app/components/App/Header/assets/brack.svg';
import { Logos } from 'dd-client/core/app/components/App/Header/types';
import { getIsRebrandingFeatureActive } from 'dd-client/site/common/utils/features';
import BrackOutlineLogo from './assets/brack-outline.svg';
import Logo from './assets/logo.svg';
import LegacyLogo from './assets/logo-legacy.svg';
import WhiteLogo from './assets/logo-white.svg';

const getLogos = (): Logos => (
  getIsRebrandingFeatureActive()
    ? {
      BrackLogo: BrackOutlineLogo,
      Logo,
      ThemeLogo: WhiteLogo,
    }
    : {
      BrackLogo,
      Logo: LegacyLogo,
    }
);

export {
  getLogos,
};
